import React from 'react';
import { Card, type CardProps } from 'react-bootstrap';

export const SxhCard = ({ className, ...props }: CardProps) => {
  return <Card className={`shadow my-2 mx-0 mx-sm-2 rounded-1 ${className ?? ''}`} {...props} />;
};
